import React from 'react';
import { useTheme } from '../context/ThemeContext';
import logoLight from '../assets/epcspark/logo/logo-light.png';
import logoDark from '../assets/epcspark/logo/logo-dark.png';

const ThemeLogo = ({ className = "", style = {}, alt = "EPC Spark" }) => {
  const { resolvedTheme } = useTheme();
  
  // Use dark logo for dark theme, light logo for light theme
  const logoSrc = resolvedTheme === 'dark' ? logoDark : logoLight;
  
  return (
    <img 
      src={logoSrc} 
      alt={alt} 
      className={className}
      style={style}
    />
  );
};

export default ThemeLogo; 